import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import TabbedFeatures, { TabbedFeaturesProps } from 'src/app/molecules/TabbedFeatures/TabbedFeatures';
import { IContentfulImage, IContentfulVideo, IStaticMixedQuery } from 'src/types/contentful';

const HeroTabbedFeatures = (): JSX.Element => {
  const assets = useStaticQuery<IStaticMixedQuery<IContentfulImage, IContentfulVideo>>(graphql`
    {
      members: contentfulAsset(contentful_id: { eq: "37TkRp9KPcrmsxW5YpaFCC" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 2400)
      }
      activityFeed: contentfulAsset(contentful_id: { eq: "4zXUoeQ8WOxgDCZu8Hl91h" }) {
        file {
          url
        }
      }
      chat: contentfulAsset(contentful_id: { eq: "55XB714g7NJ6jaukeKLGRI" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 2400)
      }
      welcome: contentfulAsset(contentful_id: { eq: "4A6ipxX7DuMEjKpAzQZiD9" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 2400)
      }
      courses: contentfulAsset(contentful_id: { eq: "6wY5AUik32b9whdINEytIu" }) {
        file {
          url
        }
      }
      events: contentfulAsset(contentful_id: { eq: "6bguXfX76e8fjTijFeqAaY" }) {
        file {
          url
        }
      }
      livestreaming: contentfulAsset(contentful_id: { eq: "6o8M7NWToumNCu7jEG1pSI" }) {
        file {
          url
        }
      }
      payments: contentfulAsset(contentful_id: { eq: "2TRh3gFcr5MTyhkC2yUqmK" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 2400)
      }
    }
  `);

  const tabs: TabbedFeaturesProps['tabs'] = [
    {
      label: 'Welcome',
      imageProps: {
        image: assets.welcome.gatsbyImageData,
        alt: 'Welcome',
      },
    },
    {
      label: 'Members',
      imageProps: {
        image: assets.members.gatsbyImageData,
        alt: 'Members',
      },
    },
    {
      label: 'Activity Feed',
      videoProps: {
        src: assets.activityFeed.file.url,
        loop: true,
        muted: true,
        controls: false,
        playsInline: true,
      },
    },
    {
      label: 'Chat',
      imageProps: {
        image: assets.chat.gatsbyImageData,
        alt: 'Chat',
      },
    },
    {
      label: 'Courses',
      videoProps: {
        src: assets.courses.file.url,
        loop: true,
        muted: true,
        controls: false,
        playsInline: true,
      },
    },
    {
      label: 'Events',
      videoProps: {
        src: assets.events.file.url,
        loop: true,
        muted: true,
        controls: false,
        playsInline: true,
      },
    },
    {
      label: 'Livestreaming',
      videoProps: {
        src: assets.livestreaming.file.url,
        loop: true,
        muted: true,
        controls: false,
        playsInline: true,
      },
    },
    {
      label: 'Payments',
      imageProps: {
        image: assets.payments.gatsbyImageData,
        alt: 'Payments',
      },
    },
  ];

  return (
    <TabbedFeatures
      tabs={tabs}
      autoChangeTimeInMilliseconds={8000}
    />
  );
};

export default HeroTabbedFeatures;
